// extracted by mini-css-extract-plugin
export default {"chipsContainer":"chipsContainer--wxOWh","container":"container--GzFp3"};